module.exports = __webpack_public_path__ + "static/media/mobile_capy_page_area04_img_cn@2x.af590315.png";